import { useEffect } from "react";
import { useLang } from "../context/LangContext";

const SITE = "https://www.holylandaward.com";

const TITLES = {
  ru: "HolyLand Award — Радиолюбительская премия Израиля",
  en: "HolyLand Award — Israel Amateur Radio Diploma",
  he: "HolyLand Award — תעודת חובבי הרדיו של ישראל",
};

const DESCRIPTIONS = {
  ru: "Неофициальное мобильное приложение дипломной программы HolyLand Award. Карта районов и квадратов Израиля, GPS check-in, прогресс по категориям Activator/Hunter, чат операторов.",
  en: "Official HolyLand Award mobile app. Israel district map and grid, GPS check-in, Activator/Hunter progress, operator chat.",
  he: 'אפליקציה רשמית של HolyLand Award. מפת מחוזות וריבועים של ישראל, צ׳ק-אין GPS, מעקב התקדמות Activator/Hunter, צ׳אט אופרטורים.',
};

// Ensure <head> has a tag matching the (selector, attrs). Returns the element.
function upsertHeadEl(selector, tagName, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(tagName);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}

// Remove all elements matching selector
function removeAll(selector) {
  document.head.querySelectorAll(selector).forEach((el) => el.remove());
}

export function SEOHead() {
  const { lang } = useLang();

  useEffect(() => {
    // Title + meta description
    document.title = TITLES[lang] || TITLES.en;
    upsertHeadEl('meta[name="description"]', "meta", {
      name: "description",
      content: DESCRIPTIONS[lang] || DESCRIPTIONS.en,
    });

    // Canonical (points to the version of the current language)
    const path = lang === "ru" ? "/ru" : lang === "en" ? "/en" : "/he";
    upsertHeadEl('link[rel="canonical"]', "link", {
      rel: "canonical",
      href: `${SITE}${path}`,
    });

    // hreflang — clear old then set fresh
    removeAll('link[rel="alternate"][hreflang]');
    const alternates = [
      { hreflang: "ru", href: `${SITE}/ru` },
      { hreflang: "en", href: `${SITE}/en` },
      { hreflang: "he", href: `${SITE}/he` },
      { hreflang: "x-default", href: `${SITE}/` },
    ];
    alternates.forEach((a) => {
      const link = document.createElement("link");
      link.setAttribute("rel", "alternate");
      link.setAttribute("hreflang", a.hreflang);
      link.setAttribute("href", a.href);
      document.head.appendChild(link);
    });

    // Open Graph for social previews
    upsertHeadEl('meta[property="og:title"]', "meta", {
      property: "og:title",
      content: TITLES[lang] || TITLES.en,
    });
    upsertHeadEl('meta[property="og:description"]', "meta", {
      property: "og:description",
      content: DESCRIPTIONS[lang] || DESCRIPTIONS.en,
    });
    upsertHeadEl('meta[property="og:type"]', "meta", {
      property: "og:type",
      content: "website",
    });
    upsertHeadEl('meta[property="og:locale"]', "meta", {
      property: "og:locale",
      content: lang === "he" ? "he_IL" : lang === "ru" ? "ru_RU" : "en_US",
    });
    upsertHeadEl('meta[property="og:url"]', "meta", {
      property: "og:url",
      content: `${SITE}${path}`,
    });
  }, [lang]);

  return null;
}
